'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import emptyFunction from 'react-utils/emptyFunction';
import UICardGrid from 'UIComponents/card/UICardGrid';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import ResultCard from './ResultCard';

const ResultsGrid = ({
  onResultClick,
  results
}) => {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const renderedResults = useMemo(() => {
    return results.toArray().map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, {
        onClick: () => {
          onResultClick(result, index);
          trackInteraction('click result item', {
            value: result.slug,
            itemIndex: index,
            totalResults: results.size,
            tier: result.tier
          });
        },
        result: result
      }, result.name);
    });
  }, [onResultClick, results, trackInteraction]);
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  });
  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({
    "data-test-id": "search-results-grid",
    gutterSize: 16
  }, responsiveProps, {
    children: renderedResults
  }));
};

ResultsGrid.propTypes = {
  onResultClick: PropTypes.func,
  results: ImmutablePropTypes.iterableOf(PropTypes.instanceOf(ProfileListing)).isRequired
};
ResultsGrid.defaultProps = {
  onResultClick: emptyFunction
};
export default ResultsGrid;